import { useContext, useState } from "react";
import { useFormik } from "formik";

import Context from "../../../context";
import Button from "../Input/Button";

import PaymentMethodPageSection from "../Layout/PaymentMethodPageSection";
import axios from "axios";
import FormField from "../Input/FormField";
import Dropdown from "../Input/Dropdown";
import PageSection from "../Layout/PageSection";
import { API_URL, STATE_LIST } from "../../data/constants";
import SummaryItem from "../Layout/SummaryItem";

export default function AutoPayPage() {
  const { contextState, setContextState } = useContext(Context);
  const [selectedMethod, setSelectedMethod] = useState([]);
  const [stateId, setStateId] = useState(1);
  const [callMessage, setCallMessage] = useState();

  let account = contextState.currentAccount;

  const [autoPay, setAutoPay] = useState(account && account.autoPay);

  function validate(values) {
    const errors = {};
    if(!values.billingName) errors.billingName = 'Required'
    //f(!values.firstName) errors.firstName = "Required"
    //if(!values.lastName) errors.lastName = 'Required'
    if(!values.billingAddress) errors.billingAddress = 'Required'
    if(!values.billingAddressCity) errors.billingAddressCity = 'Required'
    if(!values.billingAddressZipCode) errors.billingAddressZipCode = 'Required'
    return errors;
  }

  const autoPayForm = useFormik({
    initialValues: {
      billingName: "",
      billingAddress: "",
      billingAddressLine2: "",
      billingAddressCity: "",
      billingAddressStateId: "",
      billingAddressZipCode: "",
    },
    //validate,
    onSubmit: (values) => {
      values.method = selectedMethod;
      axios
        .post(
          API_URL + "/Payments/AutoPay",
          {
            billingName: values.billingName,
            billingAddress: values.billingAddress,
            billingAddressLine2: values.billingAddressLine2,
            billingAddressCity: values.billingAddressCity,
            billingAddressStateId: stateId,
            billingAddressZipCode: values.billingAddressZipCode,
            customerProfileId: selectedMethod.customerProfileId,
            paymentProfileId: selectedMethod.paymentProfileId,
            autoPay: autoPay,
            customers: [
              {
                customerId: account.contract.customerId,
                customerNumber: account.customerNumber,
                masterCustomerId: null,
              },
            ],
          },
          { headers: { Authorization: localStorage.getItem("accessToken") } }
        )
        .then((res) => {
          setCallMessage(res.data.message);
          axios
            .get(API_URL + `/Accounts/${localStorage.getItem("username")}`, {
              headers: {
                Authorization: `${localStorage.getItem("accessToken")}`,
              },
            })
            .then((res) => {
              setContextState({
                ...contextState,
                accounts: res.data,
                currentAccount: res.data.find((obj) => {
                  return obj.customerNumber === account.customerNumber;
                }),
              });
            });
        })
        .catch((err) => {
          console.error(err);
        });
    },
  });

  return (
    <div className="individual-wrapper">
      <div className="individual-header">
        <h1>Autopay</h1>
      </div>
      <form onSubmit={autoPayForm.handleSubmit}>
        <PageSection sectionName="Billing Address" isForm>
          <div className="form-row">
            <div className="col-12 col-sm-6">
              <SummaryItem
                  headerText="Enrolled in AutoPay"
                  isChecked={autoPay}
                  setIsChecked={setAutoPay}
              />
            </div>
          </div>
          <FormField
            field="billingName"
            type="text"
            name="Billing Name"
            form={autoPayForm}
            placeholder={account && account.billingName}
          />
          {/*<div className="form-row">
            <div className="col-lg-4 col-md-10 col-sm-10">
              <FormField
                field="firstName"
                type="text"
                name="First Name"
                form={autoPayForm}
              />
            </div>
            <div className="col-lg col-md-2 col-sm-2">
              <FormField
                field="middleInitial"
                type="text"
                name="M.I."
                form={autoPayForm}
              />
            </div>
            <div className="col-lg-4 col-md-12 col-sm">
              <FormField
                field="lastName"
                type="text"
                name="Last Name"
                form={autoPayForm}
              />
            </div>
          </div>*/}
          <div className="form-row">
            <div className="col-lg-12 col-md">
              <FormField
                field="billingAddress"
                type="text"
                name="Address"
                form={autoPayForm}
                placeholder={account && account.billingAddressLine1}
              />
              <FormField
                field="billingAddress2"
                type="text"
                name="Address 2"
                form={autoPayForm}
                noLabel
                helpText="Company, C/O, Apt., Suite, Unit, Building, Floor, etc..."
                optional
                placeholder={account && account.billingAddressLine2}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg-4">
              <FormField
                field="billingAddressCity"
                type="text"
                name="City"
                form={autoPayForm}
                placeholder={account && account.billingAddressCity}
              />
            </div>
            <div className="col-lg-4">
              <Dropdown
                  text="State"
                  data={STATE_LIST}
                  setValue={setStateId}
                  defaultSelectedValue={account && account.billingAddressStateId}
              />
            </div>
            <div className="col-lg-4">
              <FormField
                field="billingAddressZipCode"
                type="text"
                name="Zip Code"
                form={autoPayForm}
                placeholder={account && account.billingAddressZipCode}
              />
            </div>
          </div>
          {callMessage && <p>{callMessage}</p>}
          <div className="form-row">
            <Button
                className="btn btn--green btn--bordered"
                text="Save Information"
                type="submit"
                disabled={
                    //!(autoPayForm.dirty && autoPayForm.isValid) ||
                    selectedMethod === undefined ||
                    !selectedMethod
                }
            />
          </div>
        </PageSection>
        <PaymentMethodPageSection
          form={autoPayForm}
          hasExisting
          title="Payment Methods"
          paymentView="existing"
          noOptions
          isAutopay
          setSelectedMethod={setSelectedMethod}
        />
        <p className="page-section-warning autopay-page-section-warning">
          NOTE: the payment will be processed on the due date listed on the
          invoice.
        </p>
      </form>
    </div>
  );
}
